import React from 'react'
import {
  Card,
} from './index'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

const List = ({data, uniform, embed, bookmark}) => {
  return (
    <div>
      <div className="flex flex-wrap -mx-2 lg:-mx-4">
        {
          data && data.map((d, index) => {
            if (index > 0) {
              return (
                <div className="w-1/2 px-2 lg:px-4 mb-5 lg:mb-8" key={index}>
                  <Link to={`/event/${d.id}/detail`}>
                    <Card data={d} embed={embed} bookmark={bookmark}/>
                  </Link>
                </div>
              )
            }

            return uniform ? (
              <div className="w-1/2 px-2 lg:px-4 mb-5 lg:mb-8" key={index}>
                <Link to={`/event/${d.id}/detail`}>
                  <Card data={d} embed={embed} bookmark={bookmark}/>
                </Link>
              </div>
            ) : (
              <div className="w-full_bak w-1/2 px-2 lg:px-4 mb-5 lg:mb-8" key={index}>
                <Link to={`/event/${d.id}/detail`}>
                  <Card data={d} embed={embed} bookmark={bookmark}/>
                </Link>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

List.propTypes = {
  data: PropTypes.array,
  uniform: PropTypes.bool,
  embed: PropTypes.bool,
  bookmark: PropTypes.bool,
}

List.defaultProps = {
  data: [],
  uniform: false,
  embed: false,
  bookmark: false,
}

export { List }
